import { Badge } from "@/components/ui/badge";
import { Bug, Leaf, BadgeCheck } from "lucide-react";

const sev = {
  high: "bg-red-100 text-red-700 border-red-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  low: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const PestCard = ({ pest }) => {
  const refs = pest.references || [];
  const insectRef = refs.find((r) => /insect|scale|mealybug/i.test(r.label) && !/damage|mold|scarring|blacken/i.test(r.label));
  const damageRef = refs.find((r) => /damage|mold|scarring|blacken/i.test(r.label));
  const insectSrc = insectRef?.url || pest.insect_image;
  const damageSrc = damageRef?.url || pest.damage_image;
  const curated = refs.length > 0;

  return (
    <div data-testid={`pest-card-${pest.name}`} className="rounded-2xl border border-black/5 bg-white overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.04)]">
      <div className="grid grid-cols-2">
        <div className="relative">
          <img src={insectSrc} alt="insect" className="h-40 w-full object-cover" />
          <span className="absolute bottom-2 left-2 flex items-center gap-1 text-[10px] uppercase tracking-wider bg-black/60 text-white px-2 py-1 rounded-full"><Bug className="w-3 h-3" /> {insectRef?.label || "The Pest"}</span>
        </div>
        <div className="relative border-l-2 border-white">
          <img src={damageSrc} alt="damage" className="h-40 w-full object-cover" />
          <span className="absolute bottom-2 left-2 flex items-center gap-1 text-[10px] uppercase tracking-wider bg-black/60 text-white px-2 py-1 rounded-full"><Leaf className="w-3 h-3" /> {damageRef?.label || "The Damage"}</span>
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between gap-2">
          <h4 className="font-serif text-2xl text-emerald-950">{pest.name}</h4>
          <Badge className={`rounded-full border ${sev[pest.severity]}`}>{pest.severity} risk</Badge>
        </div>
        {curated && (
          <span data-testid={`pest-ref-badge-${pest.name}`} className="mt-2 inline-flex items-center gap-1 text-[11px] text-emerald-700">
            <BadgeCheck className="w-3.5 h-3.5" /> Verified species reference library
          </span>
        )}
        <p className="mt-3 text-sm text-stone-600"><span className="font-semibold text-stone-800">Symptoms — </span>{pest.symptom}</p>
        <p className="mt-2 text-sm text-stone-600"><span className="font-semibold text-stone-800">Treatment — </span>{pest.treatment}</p>
      </div>
    </div>
  );
};
